
import { defineComponent, PropType } from "vue";

type ProviderFilter = "all" | "openai" | "google" | "elevenlabs";

interface ReelVoice {
  id: string;
  label?: string;
  provider?: string;
  previewUrl?: string | null;
  estimatedCredits?: number;
}

const PROVIDER_CHIPS: { id: ProviderFilter; label: string }[] = [
  { id: "all", label: "All" },
  { id: "openai", label: "OpenAI" },
  { id: "google", label: "Google" },
  { id: "elevenlabs", label: "Studio" }
];

export default defineComponent({
  name: "ReelVoicePicker",
  props: {
    voices: {
      type: Array as PropType<ReelVoice[]>,
      default: () => []
    },
    modelValue: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    expanded: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "preview"],
  data() {
    return {
      searchQuery: "",
      providerFilter: "all" as ProviderFilter,
      providerChips: PROVIDER_CHIPS
    };
  },
  computed: {
    filteredVoices(): ReelVoice[] {
      const query = String(this.searchQuery || "").trim().toLowerCase();
      const provider = this.providerFilter;

      return [...this.voices]
        .filter((voice) => {
          if (provider !== "all" && String(voice.provider || "") !== provider) {
            return false;
          }
          if (!query) {
            return true;
          }
          return String(voice.label || voice.id || "").toLowerCase().includes(query);
        })
        .sort((a, b) => String(a.label || a.id || "").localeCompare(
          String(b.label || b.id || ""),
          undefined,
          { sensitivity: "base" }
        ));
    }
  },
  methods: {
    providerLabel(provider?: string): string {
      const id = String(provider || "").trim();
      if (id === "openai") return "OpenAI";
      if (id === "google") return "Google";
      if (id === "elevenlabs") return "Studio";
      return id ? id.charAt(0).toUpperCase() + id.slice(1) : "Voice";
    },
    selectVoice(voice: ReelVoice) {
      if (this.disabled || !voice?.id) {
        return;
      }
      this.$emit("update:modelValue", voice.id);
    }
  }
});
